import { VuetifyThemeVariant } from 'vuetify/types/services/theme'

const eaiTheme: Partial<VuetifyThemeVariant> = {
  primary: '#547fff',
  secondary: '#798892',
  error: '#f55d5d',
  success: '#3abf94',
  warning: '#ffc247',
  info: '#9964e3',
  accent: '#17a2b8'
}

export default eaiTheme

// default value
// {
//   primary: '#1976D2',
//   secondary: '#424242',
//   accent: '#82B1FF',
//   error: '#FF5252',
//   info: '#2196F3',
//   success: '#4CAF50',
//   warning: '#FFC107',
// }
